/**
 * Normalizes Saudi mobile numbers to E.164 (+9665XXXXXXXX).
 * Accepts "5XXXXXXXX", "05XXXXXXXX", "9665XXXXXXXX", "+966 5X XXX XXXX".
 * Returns null for anything that is not a valid Saudi mobile.
 *
 * Mirrors the Dart `normalizeSaudiPhone` so both clients agree.
 */
export function normalizeSaudiPhone(raw: string): string | null {
  let digits = raw.replace(/[^0-9]/g, '');
  if (digits.startsWith('966')) digits = digits.slice(3);
  if (digits.startsWith('05')) digits = digits.slice(1);
  if (digits.length === 9 && digits.startsWith('5')) {
    return `+966${digits}`;
  }
  return null;
}
